module.exports = __webpack_public_path__ + "img/brand-gitlab.bbf29ad4.svg";